<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">

      <!-- Register v1 -->
      <b-card v-if="estado & virtual & hora" class="mb-0">
        <b-link class="brand-logo">
          <vuexy-logo />
          <h2 class="brand-text text-primary ml-1">
            SmartAgro
          </h2>
        </b-link>

        <b-card-title class="mb-1 text-center font-weight-bold">
          {{ tema }}
        </b-card-title>
        <b-card-text class="mb-2">
          Registra tu asistencia a este evento
        </b-card-text>

        <!-- form -->
        <validation-observer ref="registerForm">
          <b-form
              class="auth-register-form mt-2"
              @submit.prevent="validationForm"
          >
            <!-- username -->
            <b-form-group
                label="DNI"
                label-for="dni"
            >
              <validation-provider
                  #default="{ errors }"
                  name="DNI"
                  rules="required|integer|min:8|max:11"
              >
                <b-form-input
                    id="dni"
                    v-model="dni"
                    :state="errors.length > 0 ? false:null"
                    name="dni"
                    placeholder="DNI"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group
                label="Nombres"
                label-for="nombres"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Nombres"
                  rules="required|min:3"
              >
                <b-form-input
                    id="nombres"
                    v-model="nombres"
                    :state="errors.length > 0 ? false:null"
                    name="nombres"
                    placeholder="Nombres"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group
                label="Género"
                label-for="genero"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Género"
                  rules="required"
              >
                <v-select
                    id="empresa_filtro"
                    v-model="genero"
                    :options="generoFiltro"
                    placeholder="Seleccionar género ..."
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group
                label="Puesto"
                label-for="puesto"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Puesto"
              >
                <b-form-input
                    id="puesto"
                    v-model="puesto"
                    :state="errors.length > 0 ? false:null"
                    name="puesto"
                    placeholder="Puesto"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group
                label="Área"
                label-for="puesto"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Área"
              >
                <b-form-input
                    id="area"
                    v-model="area"
                    :state="errors.length > 0 ? false:null"
                    name="area"
                    placeholder="Área"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- submit button -->
            <b-button
                variant="primary"
                block
                type="submit"
                :disabled="loadingRegistrar"
            >
              Registrar Asistencia &emsp;

              <span>
                <font-awesome-icon v-if="loadingRegistrar" icon="fa-solid fa-arrows-rotate" spin/>
              </span>
            </b-button>
          </b-form>
        </validation-observer>

        <div class="divider my-2">
          <div class="divider-text">
            <dark-Toggler class="d-none d-lg-block" />
          </div>
        </div>
        <span class="d-md-block text-center font-small-2 font-weight-bold text-secondary">Aplicaciones de Software &emsp14;
            <font-awesome-icon icon="fa-solid fa-code" class="text-danger stroke-current" />
          </span>

      </b-card>

      <b-card v-else class="mb-0">
        <b-link class="brand-logo">
          <vuexy-logo />
          <h2 class="brand-text text-primary ml-1">
            SmartAgro
          </h2>
        </b-link>

        <b-card-title class="mb-2 text-center font-weight-bold">
          {{ tema }}
        </b-card-title>
        <b-card-text class="mb-2 text-center text-danger font-weight-bold font-medium-3">
          Capacitación Cerrada
        </b-card-text>
        <b-card-text class="mb-2 text-center">
          La capacitación se encuentra cerrada, no podrás registrar tu asistencia porque el tiempo límite ya transcurrió.
        </b-card-text>

        <div class="divider my-2">
          <div class="divider-text">
            <dark-Toggler class="d-none d-lg-block" />
          </div>
        </div>
        <span class="d-md-block text-center font-small-2 font-weight-bold text-secondary">Aplicaciones de Software &emsp14;
            <font-awesome-icon icon="fa-solid fa-code" class="text-danger stroke-current" />
          </span>

      </b-card>
      <!-- /Register v1 -->
    </div>
  </div>

</template>

<script>
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import vSelect from 'vue-select'
import {
  BCard, BLink, BCardTitle, BCardText, BForm,
  BButton, BFormInput, BFormGroup, BInputGroup, BInputGroupAppend, BFormCheckbox,
} from 'bootstrap-vue'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import { required, min, max, integer } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import axiosIns from '@/libs/axios'

export default {
  components: {
    VuexyLogo,
    // BSV
    BCard,
    BLink,
    BCardTitle,
    BCardText,
    BForm,
    BButton,
    BFormInput,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    DarkToggler,
    // validations
    ValidationProvider,
    ValidationObserver,
    vSelect,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      regEmail: '',
      username: '',
      password: '',
      status: '',

      dni: null,
      nombres: null,
      puesto: null,
      area: null,
      genero: null,

      generoFiltro: ['M', 'F'],

      id: this.$route.params.id,
      tema: this.$route.params.tema,
      key: this.$route.params.key,
      fecha: this.$route.params.modified,

      loadingRegistrar: false,
      virtual: false,
      estado: false,
      hora: false,

      // validation rules
      required,
      min,
      max,
      integer,
    }
  },
  mounted() {
    localize("es");
    this.traerInfo();
  },
  methods: {
    traerInfo(){
      const yo = this
      const config = {
        method: 'get',
        url: 'capacitacion/capacitaciones/detalle/' + yo.$route.params.id,
        headers: {
          'Content-Type': 'application/json'
        },
      }

      axiosIns(config)

          .then(function (response) {

            if (response.status === 200){
              yo.virtual = response.data.tipo_capacitacion === 'VIRTUAL'
              yo.estado = response.data.estado === '1'
              yo.tema = response.data.tema
              yo.fecha = response.data.created
              // yo.fecha = "2023-06-30T11:00:00.156024-05:00"

              if(yo.virtual && yo.estado){
                const fechaObjeto = new Date(yo.fecha)
                const fechaActual = new Date()
                const diferenciaEnMilisegundos = fechaActual - fechaObjeto
                yo.hora = diferenciaEnMilisegundos < 3600000;
              }
            }

          })
          .catch(function (error) {
            console.log(error);
            yo.mostrarNotificacion('Error en el servidor', 'BellIcon', error.toString(), 'danger', 5000)
          })
          .finally(function (){
            yo.loadingRegistrar = false
          })

    },
    validationForm() {
      const yo = this
      this.$refs.registerForm.validate().then(success => {
        if (success) {
          yo.loadingRegistrar = true

          const data = JSON.stringify({
            'dni': yo.dni.toUpperCase(),
            'nombres': yo.nombres !=null ? yo.nombres.toUpperCase(): null,
            'genero': yo.genero !=null ? yo.genero.toUpperCase(): null,
            'cargo': yo.puesto !=null ? yo.puesto.toUpperCase(): null,
            'area': yo.area !=null ? yo.area.toUpperCase(): null,
            'estado': '0',
            'ce_capacitacion': yo.id,
            'con_evaluador': 27,
          })

          const config = {
            method: 'post',
            url: 'capacitacion/asistentes/crear/',
            headers: {
              'Content-Type': 'application/json'
            },
            data: data
          }

          axiosIns(config)

              .then(function (response) {
                // console.log(response)
                // console.log(response.data.reg_existente)

                if (response.status === 201){
                  yo.mostrarNotificacion('Asistencia registrada', 'CheckIcon', "El registro se realizó correctamente.", 'success', 10000)
                  yo.dni = null
                  yo.nombres = null
                  yo.puesto = null
                  yo.area = null
                  yo.genero = null
                }

              })
              .catch(function (error) {
                console.log(error);
                yo.mostrarNotificacion('Error en la registro', 'BellIcon', error.toString(), 'danger', 5000)
              })
              .finally(function (){

                yo.loadingRegistrar = false
              })
        }
      })
    },
    mostrarNotificacion(titulo, icono, texto, variante, tiempo){
      this.$toast({
            component: ToastificationContent,
            props:{
              title: titulo,
              icon: icono,
              text: texto,
              variant: variante
            }
          },
          {
            timeout: tiempo,
            position: 'top-center',
          })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/pages/page-auth.scss';
</style>
